import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import PaymentForm from './PaymentForm';

class PaymentModal extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			show        : false,
			userAddress : {},
		};
	}

	openModal = ({ userAddress }) => {
		this.setState({
			show : true,
			userAddress,
		});
	}

	closeModal = () => {
		this.setState({
			show : false,
		});
	}

	onDone = () => {
		const { onDone } = this.props;
		if (onDone) onDone();

		this.closeModal();
	}

	render() {
		const { show, userAddress } = this.state;
		const { addButtonText } = this.props;
		return (
			<Modal
				keyboard={false}
				backdrop="static"
				show={show}
				id="prepay-payment-modal"
				onHide={this.closeModal}
			>
				<Modal.Header
					closeButton
					className="ready"
				>
					<Modal.Title>
						Payment Method
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<PaymentForm
						userAddress={userAddress}
						onDone={this.onDone}
						showDisclaimer
						isModal
						addButtonText={addButtonText}
					/>
				</Modal.Body>
			</Modal>
		);
	}
}

PaymentModal.propTypes = {
	onDone        : PropTypes.func,
	addButtonText : PropTypes.string,
};

PaymentModal.defaultProps = {
	onDone        : undefined,
	addButtonText : 'Add Payment Method',
};

export default PaymentModal;
